import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { MessageService, ConfirmationService } from 'primeng/api';
import { MedicoService } from 'src/app/services/medico.service';
import { RedimirMedico } from 'src/app/models/redimir.interface';
import { environment } from 'src/environments/environment';
import { DESCRIPCION_STATUS_CANJE } from 'src/app/shared/constantes/constants';

@Component({
  selector: 'app-medico-canje-detalle',
  templateUrl: './medico-canje-detalle.component.html',
  styleUrls: ['./medico-canje-detalle.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class MedicoCanjeDetalleComponent implements OnInit {
  readonly urlbase = environment.urlbase;
  idRedimir!: string;
  redimir!: RedimirMedico;
  statusCanje: string[] = [...DESCRIPCION_STATUS_CANJE];

  constructor(
    private medicoService: MedicoService,
    private activedRoute: ActivatedRoute,
    private messageService: MessageService,
    private location: Location,
    private router: Router,
    private confirmationService: ConfirmationService) {

    this.idRedimir = this.activedRoute.snapshot.params['id'];
    this.obtenerInformacion(this.idRedimir);
  }

  ngOnInit(): void {
  }

  obtenerInformacion(id: string): void {
    this.medicoService.getRedimirMedicoDetalles(id)
      .subscribe({
        next: (resp) => { this.redimir = resp.datos; this.showSuccess(resp.mensaje) },
        error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
      })
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  getDescripcion(): string {
    return this.statusCanje[this.redimir.status];
  }
}
